import React, { type ReactNode } from 'react';
import Card from './Card';

interface ResponsiveTableCardProps {
    children: ReactNode;
    className?: string;
    noCard?: boolean; // Option to remove card wrapper on mobile
}

/**
 * A responsive wrapper for tables that optimizes spacing on mobile devices
 * - Removes Card wrapper on mobile when noCard is true
 * - Applies responsive padding
 * - Can wrap DataTable components
 */
const ResponsiveTableCard: React.FC<ResponsiveTableCardProps> = ({ children, className = '', noCard = false }) => {
    // On mobile, optionally render without Card wrapper
    if (noCard) {
        return (
            <>
                {/* Mobile: No card wrapper */}
                <div className={`sm:hidden ${className}`}>{children}</div>

                {/* Tablet and up: With card wrapper */}
                <div className={`hidden sm:block ${className}`}>
                    <Card responsivePadding bodyClassName="!p-0 sm:!p-2 md:!p-4">
                        {children}
                    </Card>
                </div>
            </>
        );
    }

    // Default: Always use Card with responsive padding
    return (
        <Card responsivePadding bodyClassName="!p-0 sm:!p-2 md:!p-4" className={className}>
            {children}
        </Card>
    );
};

export default ResponsiveTableCard;
